import React from 'react';

import { useWrapRequest } from '@components/hooks/use-wrap-request';
import { Api } from '@core/api';
import { injectTSDI } from '@core/tsdi';

export function useCalculatedMetricDefinitionsStore() {
    const { fitnessActivityClient } = injectTSDI(Api);

    const definitions = useWrapRequest(
        async () => {
            const result =
                await fitnessActivityClient.admin.workoutCalculatedMetricDefinitionControllerGetAll();
            const data = result.data ?? [];

            return {
                content: data,
                number: 0,
                size: data.length,
                totalElements: data.length
            };
        },
        {
            defaultData: {
                content: [],
                number: 0,
                size: 0,
                totalElements: 0
            }
        }
    );

    React.useEffect(() => {
        definitions.request([]);
    }, []);

    const refresh = () => {
        definitions.request([]);
    };

    return { definitions, refresh };
}
